function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f26524",
  d: "M15.922 9.882a2.75 2.75 0 0 0-2.69 2.2h-.708a2.1 2.1 0 0 0-2.092 2.092v1.476a1.922 1.922 0 0 1-3.843 0v-2.5a6.047 6.047 0 0 0 5.49-6.014v-.548h-1.1V3.294A2.748 2.748 0 0 0 8.235.549V0h-1.1v2.2h1.1v-.553a1.649 1.649 0 0 1 1.647 1.647v3.294h-1.1v.549a2.745 2.745 0 0 1-5.49 0v-.549H2.2V3.294a1.649 1.649 0 0 1 1.643-1.647V2.2h1.1V0h-1.1v.549A2.748 2.748 0 0 0 1.1 3.294v3.294H0v.549a6.047 6.047 0 0 0 5.49 6.014v2.5a3.02 3.02 0 0 0 6.039 0v-1.48a1 1 0 0 1 .994-.994h.708a2.745 2.745 0 1 0 2.69-3.294zm.549 3.294h-1.1v-1.1h1.1z",
  transform: "translate(2.667 2.667)"
});

function SvgColorIconStethoscope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIconStethoscope);
export default __webpack_public_path__ + "static/media/colorIconStethoscope.52c5cee6.svg";
export { ForwardRef as ReactComponent };